/**
 * Signature Lacrosse shipping progress bar
 *
 * Custom element that updates a free shipping progress bar in the announcement bar
 * whenever the cart changes. Listens for Sportive's native 'line-item:change:end'
 * event, and additionally wraps window.fetch to catch /cart/add, /cart/change,
 * /cart/update, and /cart/clear calls from any source (theme JS, third-party apps).
 */
(function () {
  'use strict';

  function patchFetchOnce() {
    if (window.__sigShipProgressFetchPatched) return;
    window.__sigShipProgressFetchPatched = true;

    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = '';
      try {
        url = typeof arguments[0] === 'string' ? arguments[0] : arguments[0].url || '';
      } catch (e) {}

      var promise = originalFetch.apply(this, arguments);

      if (url && /\/cart\/(add|change|update|clear)/.test(url)) {
        promise.then(function () {
          document.dispatchEvent(new CustomEvent('sig-ship-progress:cart-mutated'));
        }).catch(function () {});
      }

      return promise;
    };
  }

  function formatMoney(cents) {
    if (cents % 100 === 0) {
      return '$' + (cents / 100).toFixed(0);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  class SigShipProgress extends HTMLElement {
    constructor() {
      super();
      this.threshold = parseInt(this.dataset.threshold, 10) || 0;
      this.emptyMessage = this.dataset.emptyMessage || '';
      this.progressMessage = this.dataset.progressMessage || '';
      this.successMessage = this.dataset.successMessage || '';
      this.textEl = this.querySelector('.sig-ship-progress__text');
      this.fillEl = this.querySelector('.sig-ship-progress__fill');
      this._boundRefresh = this.refreshFromServer.bind(this);
    }

    connectedCallback() {
      patchFetchOnce();
      document.addEventListener('line-item:change:end', this._handleCartEvent.bind(this));
      document.addEventListener('sig-ship-progress:cart-mutated', this._boundRefresh);
    }

    disconnectedCallback() {
      document.removeEventListener('line-item:change:end', this._handleCartEvent.bind(this));
      document.removeEventListener('sig-ship-progress:cart-mutated', this._boundRefresh);
    }

    _handleCartEvent(event) {
      if (event && event.detail && event.detail.cart && typeof event.detail.cart.total_price === 'number') {
        this.update(event.detail.cart.total_price);
      } else {
        this.refreshFromServer();
      }
    }

    refreshFromServer() {
      var self = this;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (cart && typeof cart.total_price === 'number') {
            self.update(cart.total_price);
          }
        })
        .catch(function () {});
    }

    update(totalPrice) {
      if (!this.threshold || !this.fillEl || !this.textEl) return;

      var pct = (totalPrice / this.threshold) * 100;
      if (pct > 100) pct = 100;
      if (pct < 0) pct = 0;
      this.fillEl.style.width = pct + '%';

      this.classList.remove(
        'sig-ship-progress--empty',
        'sig-ship-progress--progress',
        'sig-ship-progress--complete'
      );

      if (totalPrice >= this.threshold) {
        this.classList.add('sig-ship-progress--complete');
        this.textEl.textContent = this.successMessage;
      } else if (totalPrice > 0) {
        this.classList.add('sig-ship-progress--progress');
        var remaining = this.threshold - totalPrice;
        this.textEl.textContent = this.progressMessage.replace('[amount]', formatMoney(remaining));
      } else {
        this.classList.add('sig-ship-progress--empty');
        this.textEl.textContent = this.emptyMessage;
      }
    }
  }

  if (!customElements.get('sig-ship-progress')) {
    customElements.define('sig-ship-progress', SigShipProgress);
  }
})();